import { api } from "utils/api";

import type { PaymentValues } from "./Payment.types";

export const addSubscription = (addSubscriptionData: PaymentValues) => api.post("/subscription", { ...addSubscriptionData });
